import { createAction } from 'redux-actions';

import { generateApiActions } from './action-helpers';

const types = {
  FETCH_TASKS: 'FETCH_TASKS',
  CREATE_TASK: 'CREATE_TASK',
  UPDATE_TASK: 'UPDATE_TASK',
  DELETE_TASK: 'DELETE_TASK',
};

export const {
  createTaskRequest,
  createTaskSuccess,
  createTaskFailure,
} = generateApiActions(types.CREATE_TASK);

export const {
  updateTaskRequest,
  updateTaskSuccess,
  updateTaskFailure,
} = generateApiActions(types.UPDATE_TASK);

export const {
  deleteTaskRequest,
  deleteTaskSuccess,
  deleteTaskFailure,
} = generateApiActions(types.DELETE_TASK);

export const {
  fetchTasksRequest,
  fetchTasksSuccess,
  fetchTasksFailure,
} = generateApiActions(types.FETCH_TASKS);

export const setPage = createAction('SET_TASKS_PAGE');
export const setActiveTab = createAction('SET_ACTIVE_TAB');
export const setFilter = createAction('SET_TASKS_FILTER');

export const resetTasksData = createAction('RESET_TASKS_DATA');
export const resetFilters = createAction('RESET_TASKS_FILTER');



// WEBPACK FOOTER //
// ./src/redux/actions/tasks.js